import * as React from 'react';

import { ModuleLayout } from '~/shared/layouts/ModuleLayout';
import { NavItem } from '~/shared/routing/createModuleNav';

export type CustomerPortalLayoutProps = {
  children: React.ReactNode;
  moduleNavigation?: NavItem;
};

export const CustomerPortalLayout = ({
  children,
  moduleNavigation,
}: CustomerPortalLayoutProps) => (
  <ModuleLayout
    noContentPadding={true}
    moduleNavigation={moduleNavigation}
    className="@CustomerPortalLayout"
  >
    {children}
  </ModuleLayout>
);
